import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers"

const API_URL = Global.url;
const SYS = Global.system;

class AreaOrgService {
    getAreaOrganigrama() {
        let ruta = `${API_URL}/organizational/organigrama`;
        return axios
            .get(ruta, {
                headers: headerRequest(),
            })
            .catch((error) => {
                return error;
            });
    }

    getOrganigramaArea(url, id_areaOrg) {
        let ruta = `${API_URL}/organizational/area/${id_areaOrg}?sys=${SYS}&url=${url}`;
        return axios.get(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }
}

export default new AreaOrgService();
